import utilsConstants from '../utils';
import homeSave from '../../Images/membership/plan-card-images/home-save.svg';
import homeDelux from '../../Images/membership/plan-card-images/home-delux.svg';
import homePremiere from '../../Images/membership/plan-card-images/home-premiere.svg';
import homeSaveMobile from '../../Images/membership/plan-card-images/home-save-mobile.svg';
import homeDeluxMobile from '../../Images/membership/plan-card-images/home-delux-mobile.svg';
import homePremiereMobile from '../../Images/membership/plan-card-images/home-premiere-mobile.svg';

export default {
	plans: {
        [utilsConstants.PLANS_IDS.PROPERTY_SAVE]: {
            imageDesktop: homeSave,
            imageMobile: homeSaveMobile
        },
        [utilsConstants.PLANS_IDS.PROPERTY_DELUXE]: {
            imageDesktop: homeDelux,
            imageMobile: homeDeluxMobile
        },
        [utilsConstants.PLANS_IDS.PROPERTY_PREMIERE]: {
            imageDesktop: homePremiere,
            imageMobile: homePremiereMobile
        }
    },
    sessionKey: 'pm-company',
    coverage_types: { 
        SINGLE_PROPERTY: 'SINGLE_PROPERTY',
        MULTIPLE_PROPERTIES: 'MULTIPLE_PROPERTIES'
    },
    contactDetails: {
        email: 'juliet@puls.com',
        phone: '713-913-4779'
    }
}